/**
 * Ctrl/Cmd+E toggles inline code on the highlighted text (Notion shortcut).
 */

import { useEffect } from 'react';
import { toggleInlineCode } from '../utils/inlineCode';

export function useInlineCodeShortcut(editorRootRef) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (!(e.ctrlKey || e.metaKey) || e.key !== 'e') return;
      const root = editorRootRef.current;
      if (!root || !root.contains(document.activeElement)) return;
      if (toggleInlineCode()) e.preventDefault();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [editorRootRef]);
}
